import React, { useEffect } from "react";
// import Slider from "@mui/material/Slider";

function valuetext(value) {
  return `${value}°C`;
}

const FilterMinMaxMemo = ({ label, filtered, setFiltered, dMin, dMax, val }) => {

  const [value, setValue] = React.useState([
   filtered ? filtered.min : dMin,
   filtered ? filtered.max : dMax,
  ]);
  useEffect(() => {
  if (filtered) {
    const nextMin = typeof filtered.min === "number" && !isNaN(filtered.min) ? filtered.min : dMin;
    const nextMax = typeof filtered.max === "number" && !isNaN(filtered.max) ? filtered.max : dMax;

    setValue((prevValue) =>
      prevValue[0] === nextMin && prevValue[1] === nextMax ? prevValue : [nextMin, nextMax]
    );
  }
}, [filtered, dMin, dMax]);

  const handleMinTextChange = (setVal) => {
    const x = setVal;

    // Test if the text matches the decimal pattern
    let y = !isNaN(parseFloat(setVal));

    if (y) {
      // console.log("Min y", val, x);
      setFiltered(val, {
        min: parseFloat(x + ".0"),
        max: value[1],
      });
      setValue((prevValue) => [x, prevValue[1]]);
    } else {
      // empty/invalid input: keep showing what the user typed, don't push NaN
      // into filter state — handleBlurMin resolves it to a valid value on blur.
      setValue((prevValue) => [x, prevValue[1]]);
    }
  };

  const handleMaxTextChange = (setVal) => {
    const x = setVal;

    let y = !isNaN(parseFloat(setVal));

    if (y) {
      // console.log("Max y", val, x);

      setFiltered(val, {
        max: parseFloat(x + ".0"),
        min: value[0],
      });
      setValue((prevValue) => [prevValue[0], x]);
    } else {
      // empty/invalid input: keep showing what the user typed, don't push NaN
      // into filter state — handleBlurMax resolves it to a valid value on blur.
      setValue((prevValue) => [prevValue[0], x]);
    }
  };

  const handleBlurMin = (setVal) => {
    setVal = parseFloat(setVal);
    const x = isNaN(setVal) || setVal < dMin ? dMin : setVal;
    const currentMax = parseFloat(value[1]);
    const max = isNaN(currentMax) ? dMax : currentMax;

    const newValue = max < x ? [max, max] : [x, max];
    setValue(newValue);
    setFiltered(val, {
      max: newValue[1],
      min: newValue[0],
    });
  };

  const handleBlurMax = (setVal) => {
    setVal = parseFloat(setVal);
    const x = isNaN(setVal) || setVal > dMax ? dMax : setVal;
    const currentMin = parseFloat(value[0]);
    const min = isNaN(currentMin) ? dMin : currentMin;

    const newValue = min > x ? [min, min] : [min, x];
    setValue(newValue);
    setFiltered(val, {
      max: newValue[1],
      min: newValue[0],
    });
  };

  const valueChanged = (setVal, filteredVal) => {
    return setVal != filteredVal;
  };

  const renderCaratMinMax = (val, minMaxVal, text) => {
    if (val == "Carat") {
      return <div className="text-xs font-medium m-0 inline w-max text-neutral-400">{text}: {minMaxVal}</div>;
    }
  };

  return (
    <div className="w-full flex flex-col">
      <div className="flex gap-1 justify-between ">
        <h6 className="text-xs font-medium py-1 px-2 m-0 align-middle w-[100px] self-center">{label}</h6>
        <div className="flex flex-col">
          <div className="flex flex-row justify-around">
            {renderCaratMinMax(val, dMin, "Min")}
            {renderCaratMinMax(val, dMax, "Max")}
          </div>
          <div className="flex flex-row ">
            <input
              type="number"
              className={`w-[9.5rem] text-[0.7rem] border-[#EAEAEA] border-solid outline-none rounded-xl px-2 text-center py-1 ${valueChanged(value[0], dMin) ? "font-bold text-[#0075FF]" : ""}`}
              value={value[0]}
              onChange={(ev) => {
                handleMinTextChange(ev.target.value == "" ? "" : ev.target.value);
              }}
              onFocus={(ev) => {
                if (ev.target.value == 0 || ev.target.value == -9999 || ev.target.value == -999) ev.target.value = "";
              }}
              onBlur={() => handleBlurMin(value[0])}
            />
            <div>-</div>
            <input
              type="number"
              className={`w-[9.5rem] text-[0.7rem] border-[#EAEAEA] border-solid outline-none rounded-xl px-2 text-center py-1 ${valueChanged(value[1], dMax) ? "font-bold text-[#0075FF]" : ""}`}
              value={value[1]}
              onChange={(ev) => {
                handleMaxTextChange(ev.target.value == "" ? "" : ev.target.value);
              }}
              onFocus={(ev) => {
                if (ev.target.value == 100 || ev.target.value == 9999 || ev.target.value == 999999) ev.target.value = "";
              }}
              onBlur={() => handleBlurMax(value[1])}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterMinMaxMemo;
